/**
 * Typed event helpers for track-related cross-component communication.
 * Provides compile-time safety on event payloads and centralizes event names.
 */

export interface TrackTimeChangePayload {
  layerId: string;
  startTime: Date;
  endTime: Date;
}

const TRACK_TIME_CHANGE_EVENT = 'trackTimeChange';

export function dispatchTrackTimeChange(payload: TrackTimeChangePayload) {
  window.dispatchEvent(
    new CustomEvent(TRACK_TIME_CHANGE_EVENT, { detail: payload }),
  );
}

export function onTrackTimeChange(
  handler: (payload: TrackTimeChangePayload) => void,
): () => void {
  const listener = (e: Event) => {
    const { layerId, startTime, endTime } = (e as CustomEvent).detail;
    handler({
      layerId,
      startTime: new Date(startTime),
      endTime: new Date(endTime),
    });
  };
  window.addEventListener(TRACK_TIME_CHANGE_EVENT, listener);
  return () => window.removeEventListener(TRACK_TIME_CHANGE_EVENT, listener);
}
